// extracted by mini-css-extract-plugin
module.exports = {"tabList":"Tabs_tabList__3-2ga","tabButton":"Tabs_tabButton__3asvR","inactiveTab":"Tabs_inactiveTab__3Cxor","hidden":"Tabs_hidden__lDLk1"};